// Mock data para Agenda Cheia

// Templates de negócios para agendamento
export const agendaTemplates = [
  {
    id: 'barbearia',
    name: 'Barbearia',
    icon: 'Scissors',
    description: 'Cortes, barba e tratamentos',
    services: [
      { id: 1, name: 'Corte Masculino', duration: 30, price: 35 },
      { id: 2, name: 'Barba', duration: 20, price: 25 },
      { id: 3, name: 'Corte + Barba', duration: 45, price: 55 },
      { id: 4, name: 'Pigmentação', duration: 40, price: 45 },
      { id: 5, name: 'Hidratação', duration: 30, price: 40 },
      { id: 6, name: 'Sobrancelha', duration: 15, price: 15 },
    ]
  },
  {
    id: 'salao',
    name: 'Salão de Beleza',
    icon: 'Sparkles',
    description: 'Cabelo, unhas e estética',
    services: [
      { id: 1, name: 'Corte Feminino', duration: 45, price: 60 },
      { id: 2, name: 'Escova', duration: 40, price: 50 },
      { id: 3, name: 'Progressiva', duration: 180, price: 200 },
      { id: 4, name: 'Coloração', duration: 120, price: 150 },
      { id: 5, name: 'Manicure', duration: 45, price: 35 },
      { id: 6, name: 'Pedicure', duration: 50, price: 40 },
      { id: 7, name: 'Design de Sobrancelha', duration: 30, price: 40 },
    ]
  },
  {
    id: 'petshop',
    name: 'Pet Shop',
    icon: 'Dog',
    description: 'Banho, tosa e veterinário',
    services: [
      { id: 1, name: 'Banho Pequeno Porte', duration: 60, price: 50 },
      { id: 2, name: 'Banho Médio Porte', duration: 75, price: 70 },
      { id: 3, name: 'Banho Grande Porte', duration: 90, price: 90 },
      { id: 4, name: 'Tosa Higiênica', duration: 30, price: 40 },
      { id: 5, name: 'Tosa Completa', duration: 90, price: 80 },
      { id: 6, name: 'Banho + Tosa', duration: 120, price: 120 },
      { id: 7, name: 'Consulta Veterinária', duration: 30, price: 100 },
    ]
  },
  {
    id: 'clinica',
    name: 'Clínica / Consultório',
    icon: 'Stethoscope',
    description: 'Consultas e procedimentos',
    services: [
      { id: 1, name: 'Consulta', duration: 30, price: 150 },
      { id: 2, name: 'Retorno', duration: 20, price: 80 },
      { id: 3, name: 'Avaliação', duration: 45, price: 200 },
      { id: 4, name: 'Procedimento Simples', duration: 30, price: 100 },
      { id: 5, name: 'Procedimento Complexo', duration: 60, price: 250 },
    ]
  },
  {
    id: 'estetica',
    name: 'Estética',
    icon: 'Heart',
    description: 'Massagens e tratamentos',
    services: [
      { id: 1, name: 'Limpeza de Pele', duration: 60, price: 120 },
      { id: 2, name: 'Massagem Relaxante', duration: 60, price: 100 },
      { id: 3, name: 'Drenagem Linfática', duration: 60, price: 120 },
      { id: 4, name: 'Depilação', duration: 30, price: 50 },
      { id: 5, name: 'Design de Sobrancelha', duration: 30, price: 45 },
      { id: 6, name: 'Micropigmentação', duration: 120, price: 350 },
    ]
  },
  {
    id: 'personalizado',
    name: 'Personalizado',
    icon: 'Settings',
    description: 'Configure seus próprios serviços',
    services: []
  }
];

// Horários padrão de funcionamento
export const defaultWorkingHours = {
  monday: { enabled: true, start: '09:00', end: '18:00', break_start: '12:00', break_end: '13:00' },
  tuesday: { enabled: true, start: '09:00', end: '18:00', break_start: '12:00', break_end: '13:00' },
  wednesday: { enabled: true, start: '09:00', end: '18:00', break_start: '12:00', break_end: '13:00' },
  thursday: { enabled: true, start: '09:00', end: '18:00', break_start: '12:00', break_end: '13:00' },
  friday: { enabled: true, start: '09:00', end: '18:00', break_start: '12:00', break_end: '13:00' },
  saturday: { enabled: true, start: '09:00', end: '13:00', break_start: null, break_end: null },
  sunday: { enabled: false, start: null, end: null, break_start: null, break_end: null }
};

export const weekDays = [
  { key: 'monday', label: 'Segunda' },
  { key: 'tuesday', label: 'Terça' },
  { key: 'wednesday', label: 'Quarta' },
  { key: 'thursday', label: 'Quinta' },
  { key: 'friday', label: 'Sexta' },
  { key: 'saturday', label: 'Sábado' },
  { key: 'sunday', label: 'Domingo' },
];

// Profissional de demonstração
export const demoProfessionalAgenda = {
  id: 'demo-agenda-123',
  slug: 'barbearia-do-ze',
  name: 'José Barbeiro',
  business: 'Barbearia do Zé',
  phone: '24999999999',
  email: 'ze@barbearia.com',
  address: 'Rua Principal, 123 - Centro',
  template: 'barbearia',
  services: [
    { id: 1, name: 'Corte Masculino', duration: 30, price: 35 },
    { id: 2, name: 'Barba', duration: 20, price: 25 },
    { id: 3, name: 'Corte + Barba', duration: 45, price: 55 },
    { id: 4, name: 'Sobrancelha', duration: 15, price: 15 },
  ],
  workingHours: defaultWorkingHours,
  createdAt: new Date().toISOString()
};

// Função para gerar slug
export const generateSlug = (name) => {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};

// Função para formatar duração
export const formatDuration = (minutes) => {
  if (minutes < 60) return `${minutes}min`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}min` : `${hours}h`;
};

// Função para formatar preço
export const formatPrice = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

// Gerar horários disponíveis para um dia
export const generateTimeSlots = (workingHours, serviceDuration, existingAppointments = []) => {
  if (!workingHours.enabled) return [];
  
  const slots = [];
  const start = parseInt(workingHours.start.split(':')[0]) * 60 + parseInt(workingHours.start.split(':')[1]);
  const end = parseInt(workingHours.end.split(':')[0]) * 60 + parseInt(workingHours.end.split(':')[1]);
  const breakStart = workingHours.break_start ? parseInt(workingHours.break_start.split(':')[0]) * 60 + parseInt(workingHours.break_start.split(':')[1]) : null;
  const breakEnd = workingHours.break_end ? parseInt(workingHours.break_end.split(':')[0]) * 60 + parseInt(workingHours.break_end.split(':')[1]) : null;
  
  for (let time = start; time <= end - serviceDuration; time += 30) {
    // Pular horário de almoço
    if (breakStart && breakEnd && time >= breakStart && time < breakEnd) continue;
    
    const hours = Math.floor(time / 60);
    const mins = time % 60;
    const timeStr = `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    
    // Verificar se já tem agendamento
    const isBooked = existingAppointments.some(apt => apt.time === timeStr);
    
    slots.push({
      time: timeStr,
      available: !isBooked
    });
  }
  
  return slots;
};
